"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-invalid-this */
var OListItem = function DefaultOListItem(_ref) {
  var currentClass = _ref.currentClass,
      baseClass = _ref.baseClass,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: currentClass
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(baseClass, "-list__item-counter")
  }, /*#__PURE__*/_react["default"].createElement("p", null, children)));
};

OListItem.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  baseClass: _propTypes["default"].string.isRequired,
  currentClass: _propTypes["default"].string.isRequired
};
var _default = OListItem;
exports["default"] = _default;